import type { FunctionalComponent } from 'vue'

export const MobileAuthIcon: FunctionalComponent = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 36 36" fill="none">
      <path d="M12.3516 15.6094L12.3516 19.6094" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M13.7617 16.1953L10.9333 19.0237" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M14.3477 17.6094L10.3477 17.6094" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M13.7617 19.0156L10.9333 16.1872" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M18.5547 15.6094L18.5547 19.6094" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M19.9648 16.1953L17.1364 19.0237" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M20.5508 17.6094L16.5508 17.6094" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M19.9648 19.0156L17.1364 16.1872" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M24.7539 15.6094L24.7539 19.6094" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M26.1641 16.1953L23.3356 19.0237" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M26.75 17.6094L22.75 17.6094" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M26.1641 19.0156L23.3356 16.1872" stroke="var(--colors-primary)" stroke-linejoin="round" />
      <path d="M22.25 23.9521L22.25 21.2656L9.25 21.2656L9.25 28.9521L17.25 28.9521C20.0114 28.9521 22.25 26.7136 22.25 23.9521Z" fill="var(--colors-text-base)" />
      <path d="M22.25 7.0498L22.25 13.8594L9.25 13.8594L9.25 7.04981L22.25 7.0498Z" fill="var(--colors-text-base)" />
    </svg>
  )
}
